import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  DeleteUploadedTariffDocumentResponse,
  UploadTariffDocumentResponse
} from '@core/data-access/models/api/upload-tariff-document.model';
import { FileId, FileKind } from '@core/data-access/models/file-upload.model';
import { PersonUuid } from '@core/data-access/models/person.model';
import { environment } from '@src/environments/environment';
import { OrderUuid } from '@store/customization/customization.interfaces';
import { forEach } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class UploadTariffDocumentAPI {
  readonly #http = inject(HttpClient);

  postUploadTariffDocument$(
    eventId: number,
    ticketPersonId: number,
    orderUuid: OrderUuid,
    personUuid: PersonUuid,
    fileKind: FileKind,
    files: File[]
  ) {
    const formData = new FormData();

    formData.append('orderUuid', orderUuid);
    formData.append('personUuid', personUuid);

    forEach(files, (file) => {
      formData.append(fileKind, file, file.name);
    });

    return this.#http.post<UploadTariffDocumentResponse>(
      `${environment.protocol}${environment.webApiUrl}/tickets/${eventId}/upload-tariff-document/${ticketPersonId}`,
      formData
    );
  }

  deleteUploadedTariffDocument$(orderUuid: OrderUuid, personUuid: PersonUuid, fileId: FileId) {
    return this.#http.delete<DeleteUploadedTariffDocumentResponse>(
      `${environment.protocol}${environment.webApiUrl}/tickets/${orderUuid}/${personUuid}/upload-tariff-document/${fileId}`
    );
  }
}
